import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button5Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M0 1.5C0 0.67157 0.67157 0 1.5 0C2.32843 0 3 0.67157 3 1.5V9H16V1.5C16 0.67157 16.6716 0 17.5 0C18.3284 0 19 0.67157 19 1.5V10.5V19.5C19 20.3284 18.3284 21 17.5 21C16.6716 21 16 20.3284 16 19.5V12H3V19.5C3 20.3284 2.32843 21 1.5 21C0.67157 21 0 20.3284 0 19.5V10.5V1.5Z" />
  </SvgIcon>
);

export default PO28Button5Icon;
